
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Async`}</h1>
<p>{`Always use `}<inlineCode parentName="p">{`async/await`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`.then()`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  bar().then((value) => console.log(value));
}

// Good
async function foo() {
  const value = await bar();
  console.log(value);
}
`}</code></pre>
<p>{`Always favor being explicit when working with asynchronous functions.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? In some other guides, it's stated that `}<inlineCode parentName="p">{`return await`}</inlineCode>{` is redundant and even though that's "kinda true", that just misses a whole other point far more interesting: The Principle of Least Surprise. When we're writing `}<inlineCode parentName="p">{`async/await`}</inlineCode>{` code, we expect it to behave like imperative code, however, when we forward the promise (just `}<inlineCode parentName="p">{`return bar()`}</inlineCode>{`) instead of the value (using `}<inlineCode parentName="p">{`return await bar()`}</inlineCode>{`) the `}<a parentName="p" {...{
          "href": "https://www.reddit.com/r/javascript/comments/7idasp/await_vs_return_vs_return_await/dqy2z2h/"
        }}>{`behavior would be different`}</a>{`. Also, it makes it less explicit as whether we should consume a function as asynchronous or synchronous.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  return bar();  // is bar returning a promise? should await be used with foo()?
}

// Good
async function foo() {
  return await bar();  // we know we should await for foo() when using it
}
`}</code></pre>
<p>{`Use a `}<inlineCode parentName="p">{`for`}</inlineCode>{` loop when looking for sequential execution.`}</p>
<pre><code parentName="pre" {...{}}>{`const items = [1, 2, 3, 4]

async function foo(n) {
  await new Promise((r) => setTimeout(r, Math.random() * 1000));  // wait between 0s to 1s
  console.log(n);
  return n * 2;
}

const newArray = [];
for (let item of items) {
  newArray.push(await foo(item));  // prints 1, 2, 3 and 4
}
console.log(newArray);  // prints [2, 4, 6, 8]
`}</code></pre>
<p>{`Use `}<inlineCode parentName="p">{`Promise.all`}</inlineCode>{` or `}<inlineCode parentName="p">{`array.forEach`}</inlineCode>{` when looking for parallel execution.`}</p>
<pre><code parentName="pre" {...{}}>{`const items = [1, 2, 3, 4]

async function foo(n) {
  await new Promise((r) => setTimeout(r, Math.random() * 1000));  // wait between 0s to 1s
  console.log(n);
  return n * 2;
}

const newArray = await Promise.all(items.map(foo));  // prints 2, 4, 3, 1
console.log(newArray);  // prints [2, 4, 6, 8]
items.forEach(foo);  // prints 2, 3, 1, 4
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;